export const FETCH_ACTIVITYLOG = 'FETCH_ACTIVITYLOG';
export const FETCH_ACTIVITYLOG_DEBOUNCED = 'FETCH_ACTIVITYLOG_DEBOUNCED';
export const RECEIVED_ACTIVITYLOG = 'RECEIVED_ACTIVITYLOG';
export const FAILED_ACTIVITYLOG = 'FAILED_ACTIVITYLOG';
export const ERROR_RECEIVED_FROM_API = 'ACTIVITYLOG_ERROR_RECEIVED_FROM_API';
